export type DockMode = 'dock' | 'float'
export const dockModeStorageKey = (userId: string) => `ai-assistant:window-mode:${userId}`

/** 助手窗口是停靠（默认）还是浮动：按用户记住。读写都包 try/catch，读不到就是默认的停靠。 */
export function loadDockMode(userId: string | null): DockMode {
  if (!userId) return 'dock'
  try {
    return localStorage.getItem(dockModeStorageKey(userId)) === 'float' ? 'float' : 'dock'
  } catch (err) {
    console.warn('[ai-chat] window mode not readable (storage blocked), using dock', err)
    return 'dock'
  }
}

export function saveDockMode(userId: string | null, mode: DockMode): void {
  if (!userId) return
  try {
    localStorage.setItem(dockModeStorageKey(userId), mode)
  } catch (err) {
    console.warn('[ai-chat] window mode not saved (storage blocked / full)', err)
  }
}
